import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import sendListService from "../../../services/sendList.service";
import settingScheduleService from "../../../services/settingSchedule.service";

const ResetSendList = (props: any) => {
  const { sche, curri } = props;
  const [btnReset, setBtnReset] = useState(false);
  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(sche.id).then((res) => {
        if (res.data.length > 0) {
          const count = res.data.filter(
            (x: any) => x.course.owner.id === curri.id,
          ).length;
          if (count > 0) {
            setBtnReset(true);
          }
        }
      });
    })();
  }, [curri.id, sche.id]);
  const onReset = () => {
    Swal.fire({
      title: "ล้างการตั้งค่าการส่งเอกสาร?",
      text: `(เทอม ${sche.term}/${sche.year}) หลักสูตร ${curri.name} !`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        sendListService
          .resetSendList(sche.id, curri.id)
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "มีบางอย่างทำงานผิดพลาด โปรดตรวจสอบอีกครั้งครับ",
              showConfirmButton: true,
            });
          });
      }
    });
  };

  if (btnReset)
    return (
      <>
        <button
          type="button"
          className="btn btn-sm btn-warning  ms-1"
          onClick={onReset}
        >
          <i className="bi bi-trash3"></i> Reset
        </button>
      </>
    );

  return <></>;
};

export default ResetSendList;
